<template>
    <div class="list-show row no-gutters">
        <div v-for="(item, index) in list" :key="item.id" class="col-3">
            <div class="item" @click="viewImage(item)">
                <div class="content d-flex flex-column align-items-center p-3">
                    <div class="flex-fill"></div>
                    <img class="thumb" :src="item.img | thumb" alt="" />
                    <div class="flex-fill"></div>

                    <div class="pagination">
                        {{ index + 1 }}/{{ totalPage }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { view } from "../store/preview"

export default {
    props: {
        list: Array
    },
    computed: {
        totalPage() {
            return this.list.length
        }
    },
    methods: {
        viewImage(image) {
            view(image.img)
        }
    }
}
</script>

<style lang="scss" scoped>
.list-show {
    border: 1px solid #e2e3e4;
    border-bottom: none;
    border-right: none;

    .item {
        border: 1px solid #e2e3e4;
        border-left: none;
        border-top: none;
    }
}

.item {
    padding-top: 100%;
    position: relative;
    cursor: pointer;

    .content {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    &:hover img {
        filter: brightness(110%);
    }
}

.thumb {
    max-width: 80%;
    max-height: 80%;
    transition: 0.3s;
}

.pagination {
    line-height: 50px;
}
</style>